// eslint-disable-next-line no-unused-vars
import ChatRepository from '../../../domain/repositories/ChatRepository';
// eslint-disable-next-line no-unused-vars
import Conversation from '../../../domain/entities/Conversation';

class GetOrCreateOneToOneConversationUseCase {
    /**
     * @param {ChatRepository} chatRepository
     */
    constructor(chatRepository) {
        this.chatRepository = chatRepository;
    }

    /**
     * Creates a new one-to-one conversation or returns an existing one.
     * @param {string} currentUserId
     * @param {string} currentUserName
     * @param {string} otherUserId
     * @param {string} otherUserName
     * @returns {Promise<Conversation>}
     */
    async execute(currentUserId, currentUserName, otherUserId, otherUserName) {
        return this.chatRepository.getOrCreateOneToOneConversation(currentUserId, currentUserName, otherUserId, otherUserName);
    }
}

export default GetOrCreateOneToOneConversationUseCase;
